export const Eye = (props) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
        <path
            d='M21.87 11.5c-.64-1.11-4.16-6.68-10.14-6.5-5.53.14-8.73 5-9.6 6.5a1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25c5.53-.14 8.74-5 9.6-6.5a1 1 0 0 0 0-1zM12.22 17c-4.31.1-7.12-3.59-8-5 1-1.61 3.61-4.9 7.61-5 4.29-.11 7.11 3.59 8 5-1.03 1.61-3.61 4.9-7.61 5z'
            strokeWidth='2'
            fill='currentColor'
        />
        <path
            d='M12 8.5a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 12 8.5zm0 5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z'
            strokeWidth='2'
            fill='currentColor'
        />
    </svg>
);

export const CloseEye = (props) => (
    <svg
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M2 5C2.48818 5.7811 3.01936 6.4477 3.58078 7M14 5C13.5118 5.78105 12.9808 6.44772 12.4194 7M12.4194 7L14 8.73429M12.4194 7C11.5581 7.84737 10.6254 8.42546 9.66667 8.73429M3.58078 7L2 8.73429M3.58078 7C4.44212 7.84736 5.37485 8.42546 6.33359 8.73429M9.66667 8.73429L10.3333 11M9.66667 8.73429C8.56705 9.08851 7.43321 9.0885 6.33359 8.73429M6.33359 8.73429L5.66667 11'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const Logo = (props) => (
    <svg
        viewBox='0 0 239 76'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M9.49352 55.1V33.0752H15.4336V55.1H9.49352ZM23.7768 55.1V42.104C23.7768 40.8272 23.3687 39.8392 22.5526 39.14C21.7666 38.4104 20.7841 38.0456 19.6052 38.0456C18.8192 38.0456 18.1089 38.2128 17.474 38.5472C16.8392 38.8512 16.3404 39.3072 15.9777 39.9152C15.6149 40.5232 15.4336 41.2528 15.4336 42.104L13.121 40.964C13.121 39.2616 13.4838 37.7872 14.2093 36.5408C14.965 35.2944 15.9777 34.3368 17.2473 33.668C18.517 32.9688 19.9528 32.6192 21.555 32.6192C23.0665 32.6192 24.4419 32.9688 25.6813 33.668C26.9207 34.3368 27.9031 35.2944 28.6286 36.5408C29.3541 37.7568 29.7169 39.2312 29.7169 40.964V55.1H23.7768ZM38.0602 55.1V42.104C38.0602 40.8272 37.6521 39.8392 36.8359 39.14C36.0499 38.4104 35.0675 38.0456 33.8885 38.0456C33.1328 38.0456 32.4224 38.2128 31.7574 38.5472C31.1225 38.8512 30.6238 39.3072 30.261 39.9152C29.8983 40.5232 29.7169 41.2528 29.7169 42.104L26.3161 41.2832C26.437 39.52 26.9056 38 27.7218 36.7232C28.5379 35.416 29.6111 34.4128 30.9412 33.7136C32.2713 32.984 33.7525 32.6192 35.3849 32.6192C37.0173 32.6192 38.4834 32.9688 39.7832 33.668C41.0831 34.3368 42.1109 35.3096 42.8666 36.5864C43.6223 37.8632 44.0002 39.3832 44.0002 41.1464V55.1H38.0602Z'
            fill='currentColor'
        />
        <path
            d='M57.9746 55.556C55.9795 55.556 54.1809 55.0544 52.5787 54.0512C50.9766 53.048 49.722 51.68 48.8152 49.9472C47.9083 48.2144 47.4548 46.2688 47.4548 44.1104C47.4548 41.9216 47.9083 39.9608 48.8152 38.228C49.722 36.4952 50.9766 35.1272 52.5787 34.124C54.1809 33.1208 55.9795 32.6192 57.9746 32.6192C59.5465 32.6192 60.9522 32.9384 62.1916 33.5768C63.431 34.2152 64.4135 35.112 65.139 36.2672C65.8947 37.392 66.3028 38.6688 66.3632 40.0976V48.032C66.3028 49.4912 65.8947 50.7832 65.139 51.908C64.4135 53.0328 63.431 53.9296 62.1916 54.5984C60.9522 55.2368 59.5465 55.556 57.9746 55.556ZM59.0629 50.0384C60.7255 50.0384 62.0707 49.4912 63.0985 48.3968C64.1263 47.272 64.6402 45.828 64.6402 44.0648C64.6402 42.9096 64.3983 41.8912 63.9147 41.0096C63.4612 40.0976 62.8113 39.3984 61.9649 38.912C61.1487 38.3952 60.1814 38.1368 59.0629 38.1368C57.9746 38.1368 57.0073 38.3952 56.1609 38.912C55.3447 39.3984 54.6947 40.0976 54.2111 41.0096C53.7576 41.8912 53.5309 42.9096 53.5309 44.0648C53.5309 45.2504 53.7576 46.2992 54.2111 47.2112C54.6947 48.0928 55.3447 48.792 56.1609 49.3088C57.0073 49.7952 57.9746 50.0384 59.0629 50.0384ZM64.3228 55.1V49.172L65.275 43.7912L64.3228 38.5016V33.0752H70.2175V55.1H64.3228Z'
            fill='currentColor'
        />
        <path
            d='M75.4724 55.1V33.0752H81.4124V55.1H75.4724ZM89.7557 55.1V42.104C89.7557 40.8272 89.3476 39.8392 88.5314 39.14C87.7455 38.4104 86.763 38.0456 85.5841 38.0456C84.7981 38.0456 84.0877 38.2128 83.4529 38.5472C82.8181 38.8512 82.3193 39.3072 81.9566 39.9152C81.5938 40.5232 81.4124 41.2528 81.4124 42.104L79.0999 40.964C79.0999 39.2616 79.4627 37.7872 80.1882 36.5408C80.9439 35.2944 81.9566 34.3368 83.2262 33.668C84.4958 32.9688 85.9317 32.6192 87.5339 32.6192C89.0453 32.6192 90.4208 32.9688 91.6602 33.668C92.8996 34.3368 93.882 35.2944 94.6075 36.5408C95.333 37.7568 95.6958 39.2312 95.6958 40.964V55.1H89.7557ZM104.039 55.1V42.104C104.039 40.8272 103.631 39.8392 102.815 39.14C102.029 38.4104 101.046 38.0456 99.8674 38.0456C99.1117 38.0456 98.4013 38.2128 97.7362 38.5472C97.1014 38.8512 96.6027 39.3072 96.2399 39.9152C95.8772 40.5232 95.6958 41.2528 95.6958 42.104L92.295 41.2832C92.4159 39.52 92.8845 38 93.7006 36.7232C94.5168 35.416 95.59 34.4128 96.9201 33.7136C98.2501 32.984 99.7314 32.6192 101.364 32.6192C102.996 32.6192 104.462 32.9688 105.762 33.668C107.062 34.3368 108.09 35.3096 108.845 36.5864C109.601 37.8632 109.979 39.3832 109.979 41.1464V55.1H104.039Z'
            fill='currentColor'
        />
        <path
            d='M114.794 55.1V33.0752H120.734V55.1H114.794ZM129.077 55.1V42.104C129.077 40.8272 128.669 39.8392 127.853 39.14C127.067 38.4104 126.085 38.0456 124.906 38.0456C124.12 38.0456 123.409 38.2128 122.775 38.5472C122.14 38.8512 121.641 39.3072 121.278 39.9152C120.915 40.5232 120.734 41.2528 120.734 42.104L118.422 40.964C118.422 39.2616 118.784 37.7872 119.51 36.5408C120.266 35.2944 121.278 34.3368 122.548 33.668C123.817 32.9688 125.253 32.6192 126.856 32.6192C128.367 32.6192 129.742 32.9688 130.982 33.668C132.221 34.3368 133.204 35.2944 133.929 36.5408C134.655 37.7568 135.017 39.2312 135.017 40.964V55.1H129.077ZM143.361 55.1V42.104C143.361 40.8272 142.953 39.8392 142.136 39.14C141.35 38.4104 140.368 38.0456 139.189 38.0456C138.433 38.0456 137.723 38.2128 137.058 38.5472C136.423 38.8512 135.924 39.3072 135.562 39.9152C135.199 40.5232 135.017 41.2528 135.017 42.104L131.617 41.2832C131.738 39.52 132.206 38 133.022 36.7232C133.838 35.416 134.912 34.4128 136.242 33.7136C137.572 32.984 139.053 32.6192 140.685 32.6192C142.318 32.6192 143.784 32.9688 145.084 33.668C146.384 34.3368 147.411 35.3096 148.167 36.5864C148.923 37.8632 149.301 39.3832 149.301 41.1464V55.1H143.361Z'
            fill='currentColor'
        />
        <path
            d='M164.409 55.556C162.202 55.556 160.207 55.0544 158.423 54.0512C156.67 53.0176 155.264 51.6344 154.206 49.9016C153.179 48.1384 152.665 46.1776 152.665 44.0192C152.665 41.8608 153.179 39.9304 154.206 38.228C155.234 36.4952 156.64 35.1272 158.423 34.124C160.207 33.0904 162.187 32.5736 164.363 32.5736C166.6 32.5736 168.595 33.0904 170.349 34.124C172.132 35.1272 173.538 36.4952 174.566 38.228C175.594 39.9304 176.107 41.8608 176.107 44.0192C176.107 46.1776 175.594 48.1384 174.566 49.9016C173.538 51.6344 172.132 53.0176 170.349 54.0512C168.595 55.0544 166.615 55.556 164.409 55.556ZM164.363 49.9928C165.482 49.9928 166.464 49.7496 167.311 49.2632C168.187 48.7464 168.852 48.0472 169.306 47.1656C169.79 46.2536 170.031 45.22 170.031 44.0648C170.031 42.9096 169.79 41.8912 169.306 41.0096C168.822 40.128 168.157 39.444 167.311 38.9576C166.464 38.4408 165.482 38.1824 164.363 38.1824C163.275 38.1824 162.308 38.4408 161.461 38.9576C160.615 39.444 159.95 40.128 159.466 41.0096C158.983 41.8912 158.741 42.9096 158.741 44.0648C158.741 45.22 158.983 46.2536 159.466 47.1656C159.95 48.0472 160.615 48.7464 161.461 49.2632C162.308 49.7496 163.275 49.9928 164.363 49.9928Z'
            fill='currentColor'
        />
        <path
            d='M182.62 55.1V23.9096H188.56V55.1H182.62ZM177.496 38.3192V33.0752H193.684V38.3192H177.496Z'
            fill='currentColor'
        />
        <path
            d='M211.761 55.1V42.4688C211.761 41.1616 211.353 40.0976 210.537 39.2768C209.72 38.456 208.662 38.0456 207.363 38.0456C206.516 38.0456 205.76 38.228 205.095 38.5928C204.43 38.9576 203.901 39.4744 203.508 40.1432C203.146 40.812 202.964 41.5872 202.964 42.4688L200.652 41.2832C200.652 39.5504 201.014 38.0456 201.74 36.7688C202.465 35.4616 203.463 34.4432 204.733 33.7136C206.032 32.984 207.514 32.6192 209.176 32.6192C210.839 32.6192 212.305 32.984 213.575 33.7136C214.874 34.4432 215.887 35.4464 216.613 36.7232C217.338 38 217.701 39.4744 217.701 41.1464V55.1H211.761ZM197.024 55.1V22.1312H202.964V55.1H197.024Z'
            fill='currentColor'
        />
        <path d='M0 66.5H28.3399V76H0V66.5Z' fill='currentColor' />
        <path
            d='M210.66 4.15258e-07H239V9.5H210.66V4.15258e-07Z'
            fill='currentColor'
        />
        <path
            d='M239 4.15258e-07V28.5H229.553V0L239 4.15258e-07Z'
            fill='currentColor'
        />
    </svg>
);

export const CloseIcon = (props) => (
    <svg
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path d='M4 4L12 12' stroke='white' strokeLinejoin='round' />
        <path d='M12 4L4 12' stroke='white' strokeLinejoin='round' />
    </svg>
);

export const RightArrow = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M9 18L15 12L9 6'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='square'
        />
    </svg>
);

export const LeftArrow = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M15 6L9 12L15 18'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='square'
        />
    </svg>
);

export const RightIcon = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path d='M5 12H19' stroke='currentColor' strokeWidth='2' />
        <path d='M12 5L19 12L12 19' stroke='currentColor' strokeWidth='2' />
    </svg>
);

export const AccountIcon = (props) => (
    <svg
        viewBox='0 0 37 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path d='M25 10L29.5 14L34 10' stroke='currentColor' strokeWidth='2' />
        <path
            d='M6.465 16.59C7.23 16.005 8.085 15.5436 9.03 15.2058C9.975 14.8686 10.965 14.7 12 14.7C13.035 14.7 14.025 14.8686 14.97 15.2058C15.915 15.5436 16.77 16.005 17.535 16.59C18.06 15.975 18.4689 15.2775 18.7617 14.4975C19.0539 13.7175 19.2 12.885 19.2 12C19.2 10.005 18.4989 8.3061 17.0967 6.9033C15.6939 5.5011 13.995 4.8 12 4.8C10.005 4.8 8.3064 5.5011 6.9042 6.9033C5.5014 8.3061 4.8 10.005 4.8 12C4.8 12.885 4.9464 13.7175 5.2392 14.4975C5.5314 15.2775 5.94 15.975 6.465 16.59ZM12 12.9C11.115 12.9 10.3686 12.5964 9.7608 11.9892C9.1536 11.3814 8.85 10.635 8.85 9.75C8.85 8.865 9.1536 8.1186 9.7608 7.5108C10.3686 6.9036 11.115 6.6 12 6.6C12.885 6.6 13.6314 6.9036 14.2392 7.5108C14.8464 8.1186 15.15 8.865 15.15 9.75C15.15 10.635 14.8464 11.3814 14.2392 11.9892C13.6314 12.5964 12.885 12.9 12 12.9ZM12 21C10.755 21 9.585 20.7636 8.49 20.2908C7.395 19.8186 6.4425 19.1775 5.6325 18.3675C4.8225 17.5575 4.1814 16.605 3.7092 15.51C3.2364 14.415 3 13.245 3 12C3 10.755 3.2364 9.585 3.7092 8.49C4.1814 7.395 4.8225 6.4425 5.6325 5.6325C6.4425 4.8225 7.395 4.1811 8.49 3.7083C9.585 3.2361 10.755 3 12 3C13.245 3 14.415 3.2361 15.51 3.7083C16.605 4.1811 17.5575 4.8225 18.3675 5.6325C19.1775 6.4425 19.8186 7.395 20.2908 8.49C20.7636 9.585 21 10.755 21 12C21 13.245 20.7636 14.415 20.2908 15.51C19.8186 16.605 19.1775 17.5575 18.3675 18.3675C17.5575 19.1775 16.605 19.8186 15.51 20.2908C14.415 20.7636 13.245 21 12 21ZM12 19.2C12.795 19.2 13.545 19.0839 14.25 18.8517C14.955 18.6189 15.6 18.285 16.185 17.85C15.6 17.415 14.955 17.0811 14.25 16.8483C13.545 16.6161 12.795 16.5 12 16.5C11.205 16.5 10.455 16.6161 9.75 16.8483C9.045 17.0811 8.4 17.415 7.815 17.85C8.4 18.285 9.045 18.6189 9.75 18.8517C10.455 19.0839 11.205 19.2 12 19.2ZM12 11.1C12.39 11.1 12.7125 10.9725 12.9675 10.7175C13.2225 10.4625 13.35 10.14 13.35 9.75C13.35 9.36 13.2225 9.0375 12.9675 8.7825C12.7125 8.5275 12.39 8.4 12 8.4C11.61 8.4 11.2875 8.5275 11.0325 8.7825C10.7775 9.0375 10.65 9.36 10.65 9.75C10.65 10.14 10.7775 10.4625 11.0325 10.7175C11.2875 10.9725 11.61 11.1 12 11.1Z'
            fill='currentColor'
        />
    </svg>
);

export const CartIcon = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M5.77778 21C5.28889 21 4.87022 20.823 4.52178 20.4689C4.17393 20.1142 4 19.6881 4 19.1905V8.33333C4 7.83571 4.17393 7.40987 4.52178 7.05581C4.87022 6.70114 5.28889 6.52381 5.77778 6.52381H7.55556C7.55556 5.27222 7.98904 4.20521 8.856 3.32276C9.72237 2.44092 10.7704 2 12 2C13.2296 2 14.2779 2.44092 15.1449 3.32276C16.0113 4.20521 16.4444 5.27222 16.4444 6.52381H18.2222C18.7111 6.52381 19.1298 6.70114 19.4782 7.05581C19.8261 7.40987 20 7.83571 20 8.33333V19.1905C20 19.6881 19.8261 20.1142 19.4782 20.4689C19.1298 20.823 18.7111 21 18.2222 21H5.77778ZM5.77778 19.1905H18.2222V8.33333H5.77778V19.1905ZM12 13.7619C13.2296 13.7619 14.2779 13.3207 15.1449 12.4382C16.0113 11.5564 16.4444 10.4897 16.4444 9.2381H14.6667C14.6667 9.99206 14.4074 10.6329 13.8889 11.1607C13.3704 11.6885 12.7407 11.9524 12 11.9524C11.2593 11.9524 10.6296 11.6885 10.1111 11.1607C9.59259 10.6329 9.33333 9.99206 9.33333 9.2381H7.55556C7.55556 10.4897 7.98904 11.5564 8.856 12.4382C9.72237 13.3207 10.7704 13.7619 12 13.7619ZM9.33333 6.52381H14.6667C14.6667 5.76984 14.4074 5.12897 13.8889 4.60119C13.3704 4.07341 12.7407 3.80952 12 3.80952C11.2593 3.80952 10.6296 4.07341 10.1111 4.60119C9.59259 5.12897 9.33333 5.76984 9.33333 6.52381Z'
            fill='currentColor'
        />
    </svg>
);

export const SearchIcon = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18Z'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M20 20L16 16'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='square'
            strokeLinejoin='round'
        />
    </svg>
);

export const DropDownIcon = (props) => (
    <svg
        viewBox='0 0 11 7'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path d='M1 1L5.5 5L10 1' stroke='currentColor' strokeWidth='2' />
    </svg>
);

export const ToggleIcon = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M21 18H3'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M21 14H3'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M21 10H3'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M21 6H3'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const XIcon = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M18 6L6 18'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='square'
            strokeLinejoin='round'
        />
        <path
            d='M6 6L18 18'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='square'
            strokeLinejoin='round'
        />
    </svg>
);

export const EyeIcon = (props) => (
    <svg
        viewBox='0 0 12 10'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M6 0.636475C2.18182 0.636475 0 5.00011 0 5.00011C0 5.00011 2.18182 9.36374 6 9.36374C9.81818 9.36374 12 5.00011 12 5.00011C12 5.00011 9.81818 0.636475 6 0.636475ZM7.6353 4.99986C7.6353 5.90359 6.90267 6.63622 5.99893 6.63622C5.0952 6.63622 4.36257 5.90359 4.36257 4.99986C4.36257 4.09612 5.0952 3.36349 5.99893 3.36349C6.90267 3.36349 7.6353 4.09612 7.6353 4.99986Z'
            fill='currentColor'
        />
    </svg>
);

export const HeartIcon = (props) => (
    <svg
        viewBox='0 0 10 8'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M9.22891 0.707258C8.98456 0.483037 8.69445 0.305168 8.37514 0.183815C8.05583 0.062461 7.71358 0 7.36794 0C7.0223 0 6.68005 0.062461 6.36074 0.183815C6.04143 0.305168 5.75132 0.483037 5.50697 0.707258L4.99987 1.17238L4.49277 0.707258C3.99921 0.254559 3.3298 0.00023465 2.6318 0.000234655C1.93381 0.000234659 1.2644 0.254559 0.770838 0.707258C0.277279 1.15996 5.20049e-09 1.77395 0 2.41416C-5.20049e-09 3.05438 0.277279 3.66837 0.770838 4.12107L1.27794 4.58619L4.99987 8L8.72181 4.58619L9.22891 4.12107C9.47337 3.89695 9.66729 3.63086 9.79959 3.33798C9.9319 3.0451 10 2.73119 10 2.41416C10 2.09714 9.9319 1.78322 9.79959 1.49035C9.66729 1.19747 9.47337 0.931374 9.22891 0.707258Z'
            fill='currentColor'
        />
    </svg>
);

export const TrashIcon = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M10.8889 15.6C11.0362 15.6 11.1775 15.5368 11.2817 15.4243C11.3859 15.3117 11.4444 15.1591 11.4444 15V11.4C11.4444 11.2409 11.3859 11.0883 11.2817 10.9757C11.1775 10.8632 11.0362 10.8 10.8889 10.8C10.7415 10.8 10.6002 10.8632 10.4961 10.9757C10.3919 11.0883 10.3333 11.2409 10.3333 11.4V15C10.3333 15.1591 10.3919 15.3117 10.4961 15.4243C10.6002 15.5368 10.7415 15.6 10.8889 15.6ZM16.4444 8.4H14.2222V7.8C14.2222 7.32261 14.0466 6.86477 13.7341 6.52721C13.4215 6.18964 12.9976 6 12.5556 6H11.4444C11.0024 6 10.5785 6.18964 10.2659 6.52721C9.95337 6.86477 9.77778 7.32261 9.77778 7.8V8.4H7.55556C7.40821 8.4 7.26691 8.46321 7.16272 8.57574C7.05853 8.68826 7 8.84087 7 9C7 9.15913 7.05853 9.31174 7.16272 9.42426C7.26691 9.53679 7.40821 9.6 7.55556 9.6H8.11111V16.2C8.11111 16.6774 8.28671 17.1352 8.59927 17.4728C8.91183 17.8104 9.33575 18 9.77778 18H14.2222C14.6642 18 15.0882 17.8104 15.4007 17.4728C15.7133 17.1352 15.8889 16.6774 15.8889 16.2V9.6H16.4444C16.5918 9.6 16.7331 9.53679 16.8373 9.42426C16.9415 9.31174 17 9.15913 17 9C17 8.84087 16.9415 8.68826 16.8373 8.57574C16.7331 8.46321 16.5918 8.4 16.4444 8.4ZM10.8889 7.8C10.8889 7.64087 10.9474 7.48826 11.0516 7.37574C11.1558 7.26321 11.2971 7.2 11.4444 7.2H12.5556C12.7029 7.2 12.8442 7.26321 12.9484 7.37574C13.0526 7.48826 13.1111 7.64087 13.1111 7.8V8.4H10.8889V7.8ZM14.7778 16.2C14.7778 16.3591 14.7192 16.5117 14.6151 16.6243C14.5109 16.7368 14.3696 16.8 14.2222 16.8H9.77778C9.63044 16.8 9.48913 16.7368 9.38494 16.6243C9.28075 16.5117 9.22222 16.3591 9.22222 16.2V9.6H14.7778V16.2ZM13.1111 15.6C13.2585 15.6 13.3998 15.5368 13.5039 15.4243C13.6081 15.3117 13.6667 15.1591 13.6667 15V11.4C13.6667 11.2409 13.6081 11.0883 13.5039 10.9757C13.3998 10.8632 13.2585 10.8 13.1111 10.8C12.9638 10.8 12.8225 10.8632 12.7183 10.9757C12.6141 11.0883 12.5556 11.2409 12.5556 11.4V15C12.5556 15.1591 12.6141 15.3117 12.7183 15.4243C12.8225 15.5368 12.9638 15.6 13.1111 15.6Z'
            fill='currentColor'
        />
    </svg>
);

export const FileIcon = (props) => (
    <svg
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M13.3337 5.95992C13.3267 5.89867 13.3133 5.83834 13.2937 5.77992V5.71992C13.2616 5.65137 13.2188 5.58836 13.167 5.53325L9.16699 1.53325C9.11188 1.4814 9.04887 1.43864 8.98033 1.40659H8.92033C8.8526 1.36775 8.77781 1.34281 8.70033 1.33325H4.66699C4.13656 1.33325 3.62785 1.54397 3.25278 1.91904C2.87771 2.29411 2.66699 2.80282 2.66699 3.33325V12.6666C2.66699 13.197 2.87771 13.7057 3.25278 14.0808C3.62785 14.4559 4.13656 14.6666 4.66699 14.6666H11.3337C11.8641 14.6666 12.3728 14.4559 12.7479 14.0808C13.1229 13.7057 13.3337 13.197 13.3337 12.6666V5.99992C13.3337 5.99992 13.3337 5.99992 13.3337 5.95992ZM9.33366 3.60659L11.0603 5.33325H10.0003C9.82351 5.33325 9.65395 5.26301 9.52892 5.13799C9.4039 5.01297 9.33366 4.8434 9.33366 4.66658V3.60659ZM12.0003 12.6666C12.0003 12.8434 11.9301 13.013 11.8051 13.138C11.68 13.263 11.5105 13.3333 11.3337 13.3333H4.66699C4.49018 13.3333 4.32061 13.263 4.19559 13.138C4.07056 13.013 4.00033 12.8434 4.00033 12.6666V3.33325C4.00033 3.15644 4.07056 2.98687 4.19559 2.86185C4.32061 2.73682 4.49018 2.66659 4.66699 2.66659H8.00033V4.66658C8.00033 5.19702 8.21104 5.70573 8.58611 6.0808C8.96118 6.45587 9.46989 6.66658 10.0003 6.66658H12.0003V12.6666Z'
            fill='currentColor'
        />
    </svg>
);

export const ListIcon = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M3 19V5H21V19H3ZM4.5 9.175H7.15V6.5H4.5V9.175ZM8.65 9.175H19.5V6.5H8.65V9.175ZM8.65 13.325H19.5V10.675H8.65V13.325ZM8.65 17.5H19.5V14.825H8.65V17.5ZM4.5 17.5H7.15V14.825H4.5V17.5ZM4.5 13.325H7.15V10.675H4.5V13.325Z'
            fill='currentColor'
        />
    </svg>
);

export const TileIcon = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M3 5H21V19H3V5ZM9.75 6.5V11.25H19.5V6.5H9.75ZM19.5 12.75H15.475V17.5H19.5V12.75ZM9.75 12.75V17.5H13.8V12.75H9.75ZM4.5 17.5H8.25V6.5H4.5V17.5Z'
            fill='currentColor'
        />
    </svg>
);

export const AccountMenu = (props) => (
    <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M6.465 16.59C7.23 16.005 8.085 15.5436 9.03 15.2058C9.975 14.8686 10.965 14.7 12 14.7C13.035 14.7 14.025 14.8686 14.97 15.2058C15.915 15.5436 16.77 16.005 17.535 16.59C18.06 15.975 18.4689 15.2775 18.7617 14.4975C19.0539 13.7175 19.2 12.885 19.2 12C19.2 10.005 18.4989 8.3061 17.0967 6.9033C15.6939 5.5011 13.995 4.8 12 4.8C10.005 4.8 8.3064 5.5011 6.9042 6.9033C5.5014 8.3061 4.8 10.005 4.8 12C4.8 12.885 4.9464 13.7175 5.2392 14.4975C5.5314 15.2775 5.94 15.975 6.465 16.59ZM12 12.9C11.115 12.9 10.3686 12.5964 9.7608 11.9892C9.1536 11.3814 8.85 10.635 8.85 9.75C8.85 8.865 9.1536 8.1186 9.7608 7.5108C10.3686 6.9036 11.115 6.6 12 6.6C12.885 6.6 13.6314 6.9036 14.2392 7.5108C14.8464 8.1186 15.15 8.865 15.15 9.75C15.15 10.635 14.8464 11.3814 14.2392 11.9892C13.6314 12.5964 12.885 12.9 12 12.9ZM12 21C10.755 21 9.585 20.7636 8.49 20.2908C7.395 19.8186 6.4425 19.1775 5.6325 18.3675C4.8225 17.5575 4.1814 16.605 3.7092 15.51C3.2364 14.415 3 13.245 3 12C3 10.755 3.2364 9.585 3.7092 8.49C4.1814 7.395 4.8225 6.4425 5.6325 5.6325C6.4425 4.8225 7.395 4.1811 8.49 3.7083C9.585 3.2361 10.755 3 12 3C13.245 3 14.415 3.2361 15.51 3.7083C16.605 4.1811 17.5575 4.8225 18.3675 5.6325C19.1775 6.4425 19.8186 7.395 20.2908 8.49C20.7636 9.585 21 10.755 21 12C21 13.245 20.7636 14.415 20.2908 15.51C19.8186 16.605 19.1775 17.5575 18.3675 18.3675C17.5575 19.1775 16.605 19.8186 15.51 20.2908C14.415 20.7636 13.245 21 12 21ZM12 19.2C12.795 19.2 13.545 19.0839 14.25 18.8517C14.955 18.6189 15.6 18.285 16.185 17.85C15.6 17.415 14.955 17.0811 14.25 16.8483C13.545 16.6161 12.795 16.5 12 16.5C11.205 16.5 10.455 16.6161 9.75 16.8483C9.045 17.0811 8.4 17.415 7.815 17.85C8.4 18.285 9.045 18.6189 9.75 18.8517C10.455 19.0839 11.205 19.2 12 19.2ZM12 11.1C12.39 11.1 12.7125 10.9725 12.9675 10.7175C13.2225 10.4625 13.35 10.14 13.35 9.75C13.35 9.36 13.2225 9.0375 12.9675 8.7825C12.7125 8.5275 12.39 8.4 12 8.4C11.61 8.4 11.2875 8.5275 11.0325 8.7825C10.7775 9.0375 10.65 9.36 10.65 9.75C10.65 10.14 10.7775 10.4625 11.0325 10.7175C11.2875 10.9725 11.61 11.1 12 11.1Z'
            fill='currentColor'
        />
    </svg>
);

export const CheckMark = () => (
    <svg
        width='70'
        height='70'
        viewBox='0 0 70 70'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M35 0C15.6999 0 0 15.6999 0 35C0 54.3001 15.6999 70 35 70C54.3001 70 70 54.3001 70 35C70 15.6999 54.3001 0 35 0Z'
            fill='#66BB6A'
        />
        <path
            d='M32.2541 46.9348L20.2227 35.134L25.2059 30.2463L32.2541 37.1593L46.3505 23.3333L51.3338 28.221L32.2541 46.9348Z'
            fill='white'
        />
    </svg>
);

export const PlusIcon = (props) => (
    <svg
        viewBox='0 0 11 11'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <circle
            cx='5.5'
            cy='5.5'
            r='4.125'
            stroke='currentColor'
            strokeWidth='1.2'
        />
        <path
            d='M5.5 6.875L5.5 4.125'
            stroke='currentColor'
            strokeWidth='1.2'
            strokeLinecap='square'
        />
        <path
            d='M6.875 5.5L4.125 5.5'
            stroke='currentColor'
            strokeWidth='1.2'
            strokeLinecap='square'
        />
    </svg>
);

export const MinusIcon = (props) => (
    <svg
        viewBox='0 0 11 11'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <circle
            cx='5.5'
            cy='5.5'
            r='4.125'
            stroke='currentColor'
            strokeWidth='1.2'
        />
        <path
            d='M6.875 5.5L4.125 5.5'
            stroke='currentColor'
            strokeWidth='1.2'
            strokeLinecap='square'
        />
    </svg>
);

export const EditIcon = (props) => (
    <svg
        viewBox='0 0 14 15'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M11.2583 5.70633L8.77917 3.25633L9.59583 2.43966C9.81944 2.21605 10.0942 2.10425 10.4201 2.10425C10.7456 2.10425 11.0201 2.21605 11.2437 2.43966L12.0604 3.25633C12.284 3.47994 12.4007 3.74983 12.4104 4.066C12.4201 4.38178 12.3132 4.65147 12.0896 4.87508L11.2583 5.70633ZM10.4125 6.56675L4.22917 12.7501H1.75V10.2709L7.93333 4.08758L10.4125 6.56675Z'
            fill='currentColor'
        />
    </svg>
);

export const UpArrowIcon = (props) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' {...props}>
        <path
            d='M26.71,10.29l-10-10a1,1,0,0,0-1.41,0l-10,10,1.41,1.41L15,3.41V32h2V3.41l8.29,8.29Z'
            fill='currentColor'
        />
    </svg>
);

export const DownArrowIcon = (props) => (
    <svg
        width='10'
        height='6'
        viewBox='0 0 10 6'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M1 1L5 5L9 1'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const TimerIcon = (props) => (
    <svg viewBox='0 0 14 14' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path
            d='M7.58268 7.10217L8.89518 8.41467C9.00213 8.52161 9.0556 8.65539 9.0556 8.816C9.0556 8.97622 9.00213 9.11467 8.89518 9.23133C8.77852 9.348 8.64007 9.40633 8.47985 9.40633C8.31924 9.40633 8.1806 9.348 8.06393 9.23133L6.82435 7.99175C6.68824 7.85564 6.58615 7.70494 6.5181 7.53967C6.45004 7.37439 6.41602 7.19453 6.41602 7.00008V5.25008C6.41602 5.0848 6.47202 4.94616 6.58402 4.83416C6.69563 4.72255 6.83407 4.66675 6.99935 4.66675C7.16463 4.66675 7.30327 4.72255 7.41527 4.83416C7.52688 4.94616 7.58268 5.0848 7.58268 5.25008V7.10217ZM6.99935 2.33341C7.16463 2.33341 7.30327 2.38922 7.41527 2.50083C7.52688 2.61283 7.58268 2.75147 7.58268 2.91675C7.58268 3.08203 7.52688 3.22066 7.41527 3.33266C7.30327 3.44428 7.16463 3.50008 6.99935 3.50008C6.83407 3.50008 6.69563 3.44428 6.58402 3.33266C6.47202 3.22066 6.41602 3.08203 6.41602 2.91675C6.41602 2.75147 6.47202 2.61283 6.58402 2.50083C6.69563 2.38922 6.83407 2.33341 6.99935 2.33341ZM11.666 7.00008C11.666 7.16536 11.61 7.3038 11.498 7.41542C11.3864 7.52742 11.248 7.58342 11.0827 7.58342C10.9174 7.58342 10.779 7.52742 10.6673 7.41542C10.5553 7.3038 10.4993 7.16536 10.4993 7.00008C10.4993 6.8348 10.5553 6.69617 10.6673 6.58417C10.779 6.47255 10.9174 6.41675 11.0827 6.41675C11.248 6.41675 11.3864 6.47255 11.498 6.58417C11.61 6.69617 11.666 6.8348 11.666 7.00008ZM6.99935 10.5001C7.16463 10.5001 7.30327 10.5561 7.41527 10.6681C7.52688 10.7797 7.58268 10.9181 7.58268 11.0834C7.58268 11.2487 7.52688 11.3871 7.41527 11.4987C7.30327 11.6107 7.16463 11.6667 6.99935 11.6667C6.83407 11.6667 6.69563 11.6107 6.58402 11.4987C6.47202 11.3871 6.41602 11.2487 6.41602 11.0834C6.41602 10.9181 6.47202 10.7797 6.58402 10.6681C6.69563 10.5561 6.83407 10.5001 6.99935 10.5001ZM3.49935 7.00008C3.49935 7.16536 3.44354 7.3038 3.33193 7.41542C3.21993 7.52742 3.08129 7.58342 2.91602 7.58342C2.75074 7.58342 2.6121 7.52742 2.5001 7.41542C2.38849 7.3038 2.33268 7.16536 2.33268 7.00008C2.33268 6.8348 2.38849 6.69617 2.5001 6.58417C2.6121 6.47255 2.75074 6.41675 2.91602 6.41675C3.08129 6.41675 3.21993 6.47255 3.33193 6.58417C3.44354 6.69617 3.49935 6.8348 3.49935 7.00008ZM6.99935 12.8334C6.1924 12.8334 5.43407 12.6802 4.72435 12.3737C4.01463 12.0677 3.39727 11.6522 2.87227 11.1272C2.34727 10.6022 1.93174 9.9848 1.62568 9.27508C1.31924 8.56536 1.16602 7.80703 1.16602 7.00008C1.16602 6.19314 1.31924 5.4348 1.62568 4.72508C1.93174 4.01536 2.34727 3.398 2.87227 2.873C3.39727 2.348 4.01463 1.93228 4.72435 1.62583C5.43407 1.31978 6.1924 1.16675 6.99935 1.16675C7.80629 1.16675 8.56463 1.31978 9.27435 1.62583C9.98407 1.93228 10.6014 2.348 11.1264 2.873C11.6514 3.398 12.067 4.01536 12.373 4.72508C12.6795 5.4348 12.8327 6.19314 12.8327 7.00008C12.8327 7.80703 12.6795 8.56536 12.373 9.27508C12.067 9.9848 11.6514 10.6022 11.1264 11.1272C10.6014 11.6522 9.98407 12.0677 9.27435 12.3737C8.56463 12.6802 7.80629 12.8334 6.99935 12.8334ZM6.99935 11.6667C8.30213 11.6667 9.4056 11.2147 10.3098 10.3105C11.2139 9.40633 11.666 8.30286 11.666 7.00008C11.666 5.6973 11.2139 4.59383 10.3098 3.68966C9.4056 2.7855 8.30213 2.33341 6.99935 2.33341C5.69657 2.33341 4.5931 2.7855 3.68893 3.68966C2.78477 4.59383 2.33268 5.6973 2.33268 7.00008C2.33268 8.30286 2.78477 9.40633 3.68893 10.3105C4.5931 11.2147 5.69657 11.6667 6.99935 11.6667Z'
            fill='currentColor'
        />
    </svg>
);

export const SettingIcon = (props) => (
    <svg viewBox='0 0 15 15' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path
            d='M7.5 14.5625L5.40625 12.5H2.5V9.59375L0.4375 7.5L2.5 5.40625V2.5H5.40625L7.5 0.4375L9.59375 2.5H12.5V5.40625L14.5625 7.5L12.5 9.59375V12.5H9.59375L7.5 14.5625ZM7.5 12.8125L9.0625 11.25H11.25V9.0625L12.8125 7.5L11.25 5.9375V3.75H9.0625L7.5 2.1875L5.9375 3.75H3.75V5.9375L2.1875 7.5L3.75 9.0625V11.25H5.9375L7.5 12.8125ZM5.67188 10.1562L7.5 9.04688L9.32812 10.1562L8.84375 8.07812L10.4688 6.67188L8.32812 6.5L7.5 4.53125L6.67188 6.5L4.53125 6.67188L6.15625 8.07812L5.67188 10.1562Z'
            fill='#372E2A'
        />
    </svg>
);

export const FastIcon = (props) => (
    <svg viewBox='0 0 15 9' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path
            d='M0.210728 8.36928C0.0702427 8.24284 0 8.08468 0 7.89479C0 7.70491 0.0702427 7.54123 0.210728 7.40376L4.80843 3.23135C4.88506 3.17387 4.96807 3.1279 5.05747 3.09341C5.14687 3.05893 5.24266 3.04169 5.34483 3.04169C5.447 3.04169 5.54585 3.05893 5.64138 3.09341C5.73691 3.1279 5.81686 3.17387 5.88123 3.23135L8.40996 5.50721L12.3946 1.95548H11.1686C10.9515 1.95548 10.7693 1.88928 10.6222 1.75686C10.4751 1.62445 10.4018 1.46077 10.4023 1.26583C10.4023 1.07043 10.4759 0.906519 10.623 0.774105C10.7701 0.641692 10.952 0.575714 11.1686 0.576174H14.2337C14.4508 0.576174 14.6329 0.642381 14.7801 0.774795C14.9272 0.907209 15.0005 1.07089 15 1.26583V4.02445C15 4.21985 14.9264 4.38376 14.7793 4.51617C14.6322 4.64859 14.4503 4.71456 14.2337 4.7141C14.0166 4.7141 13.8345 4.6479 13.6874 4.51548C13.5402 4.38307 13.4669 4.21939 13.4674 4.02445V2.921L8.94636 6.98997C8.86973 7.05893 8.78672 7.1079 8.69732 7.13686C8.60792 7.16583 8.51213 7.18008 8.40996 7.17962C8.30779 7.17962 8.212 7.16537 8.1226 7.13686C8.0332 7.10836 7.95019 7.05939 7.87356 6.98997L5.34483 4.7141L1.26437 8.38652C1.12388 8.51295 0.951469 8.57617 0.747126 8.57617C0.542784 8.57617 0.363985 8.50721 0.210728 8.36928Z'
            fill='#43483C'
        />
    </svg>
);

export const VapesIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <path
            d='M7.72937 19.0991C6.31507 20.5133 3.60457 21.3382 3.13317 20.8668C2.66177 20.3954 3.48667 17.6849 4.90087 16.2706L13.1338 8.03778L15.9622 10.8662L7.72937 19.0991Z'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M20.6 3.39999C22.5159 5.31631 18.5006 8.49959 16.0951 10.838C15.9131 10.7626 15.7478 10.6521 15.6085 10.5128L13.4873 8.39139C13.348 8.2521 13.2375 8.08674 13.1621 7.90474C15.5 5.50018 18.8048 1.60434 20.6 3.39999Z'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const PreRollsIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <path
            d='M5 8H13C13.5304 8 14.0391 7.78929 14.4142 7.41421C14.7893 7.03914 15 6.53043 15 6C15 5.46957 14.7893 4.96086 14.4142 4.58579C14.0391 4.21071 13.5304 4 13 4H11'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M8 16H16C16.5304 16 17.0391 16.2107 17.4142 16.5858C17.7893 16.9609 18 17.4696 18 18C18 18.5304 17.7893 19.0391 17.4142 19.4142C17.0391 19.7893 16.5304 20 16 20H14'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M2 12H20C20.5304 12 21.0391 11.7893 21.4142 11.4142C21.7893 11.0391 22 10.5304 22 10C22 9.46957 21.7893 8.96086 21.4142 8.58579C21.0391 8.21071 20.5304 8 20 8H18'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const EdiblesIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <path
            d='M15.2878 15.4622C15.419 15.5933 15.5083 15.7603 15.5445 15.9422C15.5807 16.1241 15.5621 16.3126 15.4912 16.4839C15.4202 16.6552 15.3001 16.8017 15.1459 16.9047C14.9917 17.0077 14.8104 17.0627 14.625 17.0627C14.4396 17.0627 14.2583 17.0077 14.1041 16.9047C13.95 16.8017 13.8298 16.6552 13.7588 16.4839C13.6879 16.3126 13.6693 16.1241 13.7055 15.9422C13.7417 15.7603 13.8311 15.5933 13.9622 15.4622C14.138 15.2864 14.3764 15.1877 14.625 15.1877C14.8736 15.1877 15.112 15.2864 15.2878 15.4622ZM7.96219 14.7122C7.83105 14.8433 7.74174 15.0103 7.70554 15.1922C7.66934 15.3741 7.68789 15.5626 7.75884 15.7339C7.82979 15.9052 7.94995 16.0517 8.10413 16.1547C8.25831 16.2577 8.43957 16.3127 8.625 16.3127C8.81044 16.3127 8.9917 16.2577 9.14588 16.1547C9.30006 16.0517 9.42022 15.9052 9.49117 15.7339C9.56212 15.5626 9.58067 15.3741 9.54447 15.1922C9.50827 15.0103 9.41896 14.8433 9.28782 14.7122C9.11201 14.5364 8.8736 14.4377 8.625 14.4377C8.37641 14.4377 8.138 14.5364 7.96219 14.7122ZM8.53782 10.7878C8.66896 10.6567 8.75827 10.4897 8.79447 10.3078C8.83067 10.1259 8.81212 9.93742 8.74117 9.7661C8.67022 9.59478 8.55006 9.44834 8.39588 9.34532C8.2417 9.24229 8.06044 9.1873 7.875 9.1873C7.68957 9.1873 7.50831 9.24229 7.35413 9.34532C7.19995 9.44834 7.07979 9.59478 7.00884 9.7661C6.93789 9.93742 6.91934 10.1259 6.95554 10.3078C6.99174 10.4897 7.08105 10.6567 7.21219 10.7878C7.388 10.9636 7.62641 11.0623 7.875 11.0623C8.1236 11.0623 8.36201 10.9636 8.53782 10.7878ZM11.7122 10.9622C11.5811 11.0933 11.4917 11.2603 11.4555 11.4422C11.4193 11.6241 11.4379 11.8126 11.5088 11.9839C11.5798 12.1552 11.7 12.3017 11.8541 12.4047C12.0083 12.5077 12.1896 12.5627 12.375 12.5627C12.5604 12.5627 12.7417 12.5077 12.8959 12.4047C13.0501 12.3017 13.1702 12.1552 13.2412 11.9839C13.3121 11.8126 13.3307 11.6241 13.2945 11.4422C13.2583 11.2603 13.169 11.0933 13.0378 10.9622C12.862 10.7864 12.6236 10.6877 12.375 10.6877C12.1264 10.6877 11.888 10.7864 11.7122 10.9622ZM21.5625 12C21.5625 13.8913 21.0017 15.7401 19.9509 17.3126C18.9002 18.8852 17.4067 20.1108 15.6594 20.8346C13.9121 21.5584 11.9894 21.7477 10.1345 21.3788C8.27951 21.0098 6.57564 20.099 5.2383 18.7617C3.90096 17.4244 2.99022 15.7205 2.62125 13.8656C2.25227 12.0106 2.44164 10.0879 3.16541 8.34059C3.88917 6.59327 5.11482 5.09981 6.68736 4.04907C8.25991 2.99833 10.1087 2.4375 12 2.4375C12.1492 2.4375 12.2923 2.49676 12.3978 2.60225C12.5032 2.70774 12.5625 2.85082 12.5625 3C12.5625 4.04429 12.9773 5.04581 13.7158 5.78423C14.4542 6.52266 15.4557 6.9375 16.5 6.9375C16.6492 6.9375 16.7923 6.99676 16.8978 7.10225C17.0032 7.20774 17.0625 7.35082 17.0625 7.5C17.0625 8.54429 17.4773 9.54581 18.2158 10.2842C18.9542 11.0227 19.9557 11.4375 21 11.4375C21.1492 11.4375 21.2923 11.4968 21.3978 11.6023C21.5032 11.7077 21.5625 11.8508 21.5625 12ZM20.4206 12.5297C19.2784 12.3966 18.2153 11.8792 17.4058 11.0623C16.5963 10.2455 16.0884 9.17779 15.9656 8.03437C14.8212 7.91252 13.7523 7.40501 12.9345 6.59523C12.1167 5.78546 11.5987 4.72159 11.4656 3.57844C9.84519 3.68033 8.28856 4.2476 6.9825 5.21219C5.67644 6.17678 4.67643 7.49772 4.10245 9.01652C3.52847 10.5353 3.40489 12.1875 3.74654 13.7748C4.0882 15.3621 4.88057 16.8171 6.0286 17.9652C7.17663 19.1134 8.63155 19.9059 10.2188 20.2477C11.8061 20.5895 13.4582 20.4661 14.9771 19.8923C16.496 19.3185 17.817 18.3186 18.7817 17.0126C19.7464 15.7067 20.3139 14.1501 20.4159 12.5297H20.4206Z'
            fill='black'
        />
    </svg>
);

export const AllProductsIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='18'
        viewBox='0 0 20 18'
        fill='none'
        {...props}
    >
        <rect
            x='12.75'
            y='0.75'
            width='6.5'
            height='6.5'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <rect
            x='12.75'
            y='10.75'
            width='6.5'
            height='6.5'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <rect
            x='0.75'
            y='10.75'
            width='6.5'
            height='6.5'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <rect
            x='0.75'
            y='0.75'
            width='6.5'
            height='6.5'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const FlowersIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <path
            d='M7.00024 21C7.00024 21 7.25024 17.8235 9.00024 15'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M19.13 4.24198L19.724 10.417C20.098 14.303 17.184 17.763 13.299 18.137C9.48603 18.504 6.03203 15.717 5.66503 11.904C5.48867 10.0729 6.04691 8.24681 7.21695 6.82735C8.38699 5.40789 10.073 4.51136 11.904 4.33498L18.475 3.70298C18.5535 3.69539 18.6327 3.70335 18.7081 3.72638C18.7835 3.74942 18.8536 3.78709 18.9144 3.83724C18.9753 3.88739 19.0256 3.94904 19.0626 4.01866C19.0996 4.08828 19.1225 4.1635 19.13 4.24198Z'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const ConcentratesIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <path
            d='M11.47 2.22001C11.6106 2.07956 11.8012 2.00067 12 2.00067C12.1988 2.00067 12.3894 2.07956 12.53 2.22001C12.933 2.62301 14.529 4.34701 16.029 6.58201C17.509 8.78501 19 11.635 19 14.25C19 16.774 18.254 18.729 16.956 20.056C15.659 21.38 13.889 22 12 22C10.11 22 8.341 21.381 7.044 20.056C5.746 18.729 5 16.774 5 14.25C5 11.635 6.492 8.78501 7.971 6.58201C9.471 4.34701 11.067 2.62201 11.47 2.22001ZM9.216 7.41801C7.758 9.59001 6.5 12.115 6.5 14.25C6.5 16.476 7.153 18.021 8.117 19.007C9.082 19.994 10.437 20.5 12 20.5C13.562 20.5 14.918 19.994 15.883 19.007C16.847 18.021 17.5 16.477 17.5 14.25C17.5 12.115 16.242 9.59001 14.784 7.41801C13.9379 6.16634 13.0078 4.9736 12 3.84801C10.9922 4.97359 10.0621 6.16634 9.216 7.41801Z'
            fill='black'
        />
    </svg>
);

export const BeveragesIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <path
            d='M16.6235 2.57521C16.6794 2.63094 16.7238 2.69715 16.754 2.77005C16.7843 2.84294 16.7998 2.92109 16.7998 3.00001C16.7998 3.07893 16.7843 3.15707 16.754 3.22997C16.7238 3.30286 16.6794 3.36907 16.6235 3.42481L15.2471 4.80001H17.1959C17.3803 4.80006 17.5601 4.85672 17.7112 4.96231C17.8623 5.0679 17.9773 5.21733 18.0407 5.39041L19.1411 8.39041C19.191 8.52639 19.2072 8.67239 19.1886 8.816C19.1699 8.95962 19.1169 9.09661 19.0339 9.21534C18.951 9.33407 18.8407 9.43104 18.7123 9.498C18.5838 9.56497 18.4412 9.59996 18.2963 9.60001H17.8895L16.1795 19.6044C16.0841 20.1626 15.7944 20.6691 15.3615 21.0343C14.9287 21.3995 14.3807 21.5999 13.8143 21.6H10.1843C9.61782 21.6002 9.0695 21.3999 8.63642 21.0347C8.20333 20.6695 7.91341 20.1628 7.81795 19.6044L6.10795 9.60001H5.69995C5.55494 9.59991 5.4121 9.56478 5.28358 9.4976C5.15507 9.43042 5.0447 9.33318 4.96186 9.21416C4.87901 9.09514 4.82616 8.95787 4.80779 8.81402C4.78942 8.67018 4.80608 8.52403 4.85635 8.38801L5.96395 5.38801C6.02775 5.21538 6.14294 5.06646 6.294 4.96132C6.44505 4.85618 6.62471 4.79988 6.80875 4.80001H13.5791C13.6055 4.75437 13.6378 4.71241 13.6751 4.67521L15.7751 2.57521C15.8877 2.46273 16.0402 2.39954 16.1993 2.39954C16.3584 2.39954 16.511 2.46273 16.6235 2.57521ZM7.32595 9.60001L8.99995 19.4028C9.0478 19.6819 9.19282 19.9351 9.40935 20.1176C9.62588 20.3001 9.89997 20.4001 10.1831 20.4H13.8131C14.0961 20.3998 14.3699 20.2997 14.5862 20.1172C14.8025 19.9347 14.9473 19.6817 14.9951 19.4028L16.6727 9.60001H7.32595ZM6.13075 8.40001H17.8667L16.9859 6.00001H7.01755L6.13075 8.40001Z'
            fill='black'
        />
    </svg>
);

export const AccessoriesIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <path
            d='M19 12.4118C19 18.5 19 19 10.5 19C2 19 2 18.5 2 12C2 5.5 2 5 10.5 5C19 5 19 5.5 19 12.4118Z'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M6.25 9C6.25 9 7 10.1538 7 12C7 13.8462 6.25 15 6.25 15'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M10.25 9C10.25 9 11 10.1538 11 12C11 13.8462 10.25 15 10.25 15'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M19 9C21.5 9.5 22 9 22 12C22 15 21.5 14.5 19 15'
            stroke='black'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const ShopIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='11'
        height='14'
        viewBox='0 0 11 14'
        fill='none'
        {...props}
    >
        <path
            d='M9.59947 4.17275H7.90716C8.53448 3.89281 9.11804 3.56867 9.38064 3.3182C10.183 2.50786 10.2268 1.25551 9.49735 0.518836C9.13263 0.150498 8.63661 -0.0263045 8.11141 0.00316257C7.6008 0.0326296 7.11936 0.253632 6.74005 0.636704C6.36074 1.01978 5.87931 2.09532 5.51459 3.0088C5.14987 2.09532 4.66844 1.03451 4.28913 0.636704C3.90982 0.253632 3.42838 0.0326296 2.91777 0.00316257C2.37798 -0.0263045 1.89655 0.150498 1.53183 0.518836C0.802387 1.25551 0.860743 2.50786 1.64854 3.3182C1.91114 3.58341 2.4947 3.89281 3.12202 4.17275H1.40053C0.627321 4.17275 0 4.80629 0 5.58716V12.5856C0 13.3665 0.627321 14 1.40053 14H9.59947C10.3727 14 11 13.3665 11 12.5856V5.58716C11 4.80629 10.3727 4.17275 9.59947 4.17275ZM7.48409 1.41758C7.67374 1.22604 7.92175 1.10818 8.15517 1.09344C8.16976 1.09344 8.18435 1.09344 8.21353 1.09344C8.41777 1.09344 8.59284 1.16711 8.72414 1.29971C9.03051 1.60912 8.98674 2.16899 8.60743 2.55206C8.35942 2.80253 7.38196 3.24454 6.4191 3.62761C6.79841 2.6552 7.23607 1.66805 7.48409 1.41758ZM2.39257 2.55206C2.01326 2.16899 1.9695 1.60912 2.27586 1.29971C2.40716 1.16711 2.58223 1.09344 2.78647 1.09344C2.80106 1.09344 2.81565 1.09344 2.84483 1.09344C3.09284 1.10818 3.32626 1.22604 3.51592 1.41758C3.76393 1.66805 4.20159 2.6552 4.5809 3.62761C3.61804 3.24454 2.64058 2.80253 2.39257 2.55206ZM3.82228 6.44171C4.34748 6.44171 4.75597 6.86898 4.75597 7.38465C4.75597 7.90033 4.33289 8.3276 3.82228 8.3276C3.29708 8.3276 2.88859 7.90033 2.88859 7.38465C2.88859 6.86898 3.29708 6.44171 3.82228 6.44171ZM7.17772 11.731C6.65252 11.731 6.24403 11.3038 6.24403 10.7881C6.24403 10.2724 6.66711 9.84515 7.17772 9.84515C7.70292 9.84515 8.11141 10.2724 8.11141 10.7881C8.11141 11.3038 7.70292 11.731 7.17772 11.731ZM8.00928 7.26679L3.69098 11.6279C3.58886 11.731 3.47215 11.7752 3.34085 11.7752C3.20955 11.7752 3.09284 11.731 2.99072 11.6279C2.80106 11.4364 2.80106 11.1122 2.99072 10.9207L7.32361 6.54484C7.51326 6.35331 7.83422 6.35331 8.02387 6.54484C8.21353 6.75111 8.21353 7.06052 8.00928 7.26679Z'
            fill='#333333'
        />
    </svg>
);

export const ClockTimerIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='22'
        viewBox='0 0 18 22'
        fill='none'
        {...props}
    >
        <path
            d='M9 21C13.4183 21 17 17.4183 17 13C17 8.58172 13.4183 5 9 5C4.58172 5 1 8.58172 1 13C1 17.4183 4.58172 21 9 21Z'
            stroke='#221B38'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9 8V12'
            stroke='#221B38'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M10 13H13'
            stroke='#221B38'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9 14C9.5523 14 10 13.5523 10 13C10 12.4477 9.5523 12 9 12C8.4477 12 8 12.4477 8 13C8 13.5523 8.4477 14 9 14Z'
            stroke='#221B38'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M11.5 1H6.5V2H11.5V1Z'
            stroke='#221B38'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9.5 5V2H8.5V5H9.5Z'
            stroke='#221B38'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const ClockTimerExpiredIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill='none'
        {...props}
    >
        <path
            d='M11 21C15.4183 21 19 17.4183 19 13C19 8.58172 15.4183 5 11 5C6.58172 5 3 8.58172 3 13C3 17.4183 6.58172 21 11 21Z'
            stroke='black'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M11 8V12'
            stroke='black'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M12 13H15'
            stroke='black'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M11 14C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12C10.4477 12 10 12.4477 10 13C10 13.5523 10.4477 14 11 14Z'
            stroke='black'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M13.5 1H8.5V2H13.5V1Z'
            stroke='black'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M11.5 5V2H10.5V5H11.5Z'
            stroke='black'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M1 1L21 21'
            stroke='black'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const PhoneIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='24'
        viewBox='0 0 25 24'
        fill='none'
        {...props}
    >
        <path
            d='M16.9605 13.55L14.8405 15.67L8.83048 9.66L10.9505 7.54L6.41048 3L4.29048 5.12C2.34048 7.07 4.13048 12.03 8.30048 16.2C12.4705 20.37 17.4305 22.16 19.3805 20.21L21.5005 18.09L16.9605 13.55Z'
            fill='black'
        />
    </svg>
);

export const EmailIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <path
            d='M20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20Z'
            fill='black'
        />
        <path
            d='M20 4H4C2.9 4 2 4.9 2 6L12 13L22 6C22 4.9 21.1 4 20 4Z'
            fill='black'
        />
        <path
            d='M2 6L12 13L22 6'
            stroke='white'
            strokeMiterlimit='10'
            strokeLinecap='round'
        />
    </svg>
);

export const CheckIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='15'
        height='15'
        viewBox='0 0 15 15'
        fill='none'
        {...props}
    >
        <path
            d='M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z'
            fill='#9B51E0'
        />
        <path d='M3.75 7.50005L6.375 10.1251L11.25 4.87505' fill='#9B51E0' />
        <path
            d='M3.75 7.50005L6.375 10.1251L11.25 4.87505'
            stroke='white'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const AlertIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='67'
        height='60'
        viewBox='0 0 67 60'
        fill='none'
        {...props}
    >
        <path
            d='M64.9008 47.1427L40.7449 5.30342C36.6622 -1.76781 29.9811 -1.76781 25.8984 5.30342L1.74243 47.1427C-2.34028 54.2139 1.00028 60 9.16628 60H57.477C65.643 60 68.9835 54.2139 64.9008 47.1427ZM38.0955 51.202C38.0955 52.0853 37.7868 52.8374 37.1665 53.4548C36.5485 54.0757 35.7958 54.385 34.9119 54.385H31.7301C30.8451 54.385 30.0941 54.0757 29.4756 53.4548C28.8558 52.8374 28.5471 52.0853 28.5471 51.202V48.4724C28.5717 47.589 28.9009 46.8264 29.5318 46.1809C30.1632 45.5377 30.9206 45.2144 31.8051 45.2144H34.837C35.7215 45.2144 36.4853 45.5319 37.1296 46.1621C37.7734 46.7948 38.0955 47.5398 38.0955 48.3962V51.202ZM36.5427 38.8613C36.4665 39.7727 36.1262 40.5307 35.52 41.1364C34.9131 41.7409 34.1938 42.0455 33.3591 42.0455C32.4248 42.0455 31.661 41.7315 31.0671 41.0989C30.4731 40.4686 30.1509 39.7212 30.1006 38.8613L28.5471 14.119C28.4956 13.2627 28.7943 12.5152 29.4375 11.885C30.0818 11.2535 30.8451 10.936 31.7301 10.936H34.9131C35.7964 10.936 36.5614 11.2711 37.2058 11.94C37.8489 12.6113 38.1459 13.3622 38.0967 14.194L36.5427 38.8613Z'
            fill='#EB5757'
        />
    </svg>
);

export const InfoIcon = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='10'
        height='10'
        viewBox='0 0 10 10'
        fill='none'
        {...props}
    >
        <path
            d='M5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10ZM4.21875 6.5625H4.6875V5.3125H4.21875C3.95898 5.3125 3.75 5.10352 3.75 4.84375C3.75 4.58398 3.95898 4.375 4.21875 4.375H5.15625C5.41602 4.375 5.625 4.58398 5.625 4.84375V6.5625H5.78125C6.04102 6.5625 6.25 6.77148 6.25 7.03125C6.25 7.29102 6.04102 7.5 5.78125 7.5H4.21875C3.95898 7.5 3.75 7.29102 3.75 7.03125C3.75 6.77148 3.95898 6.5625 4.21875 6.5625ZM5 2.5C5.16576 2.5 5.32473 2.56585 5.44194 2.68306C5.55915 2.80027 5.625 2.95924 5.625 3.125C5.625 3.29076 5.55915 3.44973 5.44194 3.56694C5.32473 3.68415 5.16576 3.75 5 3.75C4.83424 3.75 4.67527 3.68415 4.55806 3.56694C4.44085 3.44973 4.375 3.29076 4.375 3.125C4.375 2.95924 4.44085 2.80027 4.55806 2.68306C4.67527 2.56585 4.83424 2.5 5 2.5Z'
            fill='#808080'
        />
    </svg>
);
